// In-memory Storage stand-in for the explicitly enabled local mock API.
// Its retained objects model uploaded media and reset when the browser reloads.
const objects = new Map<string, string>();
export function storeMockTemplateAsset(file: File, operationId: string): string {
  const reference = `https://mock-assets.ottagive.test/cards/${operationId}/${encodeURIComponent(file.name)}`;
  if (!objects.has(reference)) objects.set(reference, URL.createObjectURL(file));
  return reference;
}
export function templateDisplayUrl(reference: string): string { return objects.get(reference) ?? reference; }
